import React, { useMemo } from 'react';
import { FormField, Input } from '@cian/ui-kit';
import { OfferCalculatorSuggest } from '../OfferCalculatorSuggest';
import { RegionSuggestNotFoundContent } from '../RegionSuggestNotFoundContent';
import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';
import { useSuggestField } from '../../hooks/useSuggestField';
import { type IField } from '../../types/calculator';

export const SuggestField: React.FC<IField> = props => {
  const {
    inputValue,
    name,
    label,
    placeholder,
    disabled,
    isError,
    error,
    isSuggestOpen,
    handleSuggestSelect,
    handleSuggestClose,
    handleInputFocus,
    handleInputChange,
    suggestions,
    isRegionRemoteSearchLoading,
    regionSearchContainerRef,
    handleRegionSearchReset,
  } = useSuggestField(props);

  const emptyListContent = useMemo(() => {
    if (suggestions.length > 0) {
      return undefined;
    }

    if (inputValue.trim().length === 0) {
      return undefined;
    }

    /** Один вариант пустого состояния (JSX) при любом ненулевом вводе и пустом списке, в т.ч. во время загрузки API. */
    return <RegionSuggestNotFoundContent onChooseAgain={handleRegionSearchReset} />;
  }, [handleRegionSearchReset, inputValue, suggestions.length]);

  return (
    <FormField
      label={label}
      errorMessage={isError ? error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <OfferCalculatorSuggest
        suggestions={suggestions}
        onSelect={handleSuggestSelect}
        onClose={handleSuggestClose}
        open={isSuggestOpen}
        emptyListContent={emptyListContent}
        emptyListLoading={isRegionRemoteSearchLoading}
        highlightValue={inputValue}
      >
        <div ref={regionSearchContainerRef} data-suggest-field-input>
          <Input
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
            placeholder={getFieldPlaceholder(placeholder)}
            value={String(inputValue)}
            invalid={Boolean(isError && error)}
            name={name}
            disabled={disabled}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            size="M"
          />
        </div>
      </OfferCalculatorSuggest>
    </FormField>
  );
};

SuggestField.displayName = 'SuggestField';
